import { describe, it, expect, vi, beforeEach, afterEach } from "vitest";
import * as path from "path";
import * as fs from "fs";
import * as globModule from "glob";
import {
  analyzeProjectReferences,
  ReferenceTriple,
} from "./reference_analyzer";

// Mock console.log，避免 LSP 初始化日志输出
vi.spyOn(console, "log").mockImplementation(() => {});

// Mock依赖
vi.mock("./lsp_core", () => {
  class MockLSPClient {
    constructor() {}
    async start() {}
    async shutdown() {}
    async sendDidOpen() {}
    async sendDidClose() {}
    async sendDocumentSymbol() {
      return [
        {
          name: "foo",
          kind: 12, // Function
          location: {
            range: {
              start: { line: 0, character: 0 },
              end: { line: 0, character: 10 },
            },
          },
        },
      ];
    }
    async readFile() {
      return "function foo() {}";
    }
    async sendReferences() {
      return {
        result: [
          {
            uri: "file:///mock/path/file.ts",
            range: {
              start: { line: 1, character: 2 },
              end: { line: 1, character: 5 },
            },
          },
        ],
      };
    }
  }
  return {
    LSPClient: MockLSPClient,
    DEFAULT_CONFIG: {
      timeout: 30000,
      logLevel: "error",
    },
    SymbolKind: {
      Function: 12,
    },
  };
});

vi.mock("./os_utils", async () => {
  return {
    detectDominantLanguages: () => ["typescript"],
    getLanguageFileExtensions: () => "ts",
  };
});

vi.mock("./symbol_utils", async () => {
  return {
    checkRealFuncChar: () => ({ line: 0, character: 9 }),
  };
});

vi.mock("glob", async () => {
  return {
    glob: async () => [path.resolve("mock_project/file.ts")],
  };
});

vi.mock("fs", async () => {
  const actual = await vi.importActual<typeof fs>("fs");
  return {
    ...actual,
    readFileSync: () => "function foo() {}",
  };
});

describe("analyzeProjectReferences", () => {
  it("should return correct ReferenceTriple array", async () => {
    const result = await analyzeProjectReferences("mock_project");
    expect(result).toEqual([
      {
        caller: "../../../../../mock/path/file.ts:2:3",
        callee: "file.ts:foo",
        location: "file.ts:1:10",
      },
    ]);
  });
});
